/* istanbul ignore file */
import "@Styles/mandate.css";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { withRouter } from "../../../hooks/withRouter";
import { HEADING_CHANGE_MOBILE_NUMBER } from "../Common/constant";
import arrowleft from "@Images/NewUI/Vector.png";
import "react-toastify/dist/ReactToastify.css";
import {
  phoneNumberVerify,
  refreshToken,
  resendOtp,
  saveManualToken,
  savePhoneNumber,
  sendOtpNotExist,
} from "../../../Redux/Authenticate/action";
import ToastMsg from "../../../helper/ToastMsg";


const ChangeMobileNumber = (props) => {
  const navigate = useNavigate();
  const [pdf, setPdf] = useState("");
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [isChecked, setIsChecked] = useState(false);
  const [is_enable, setIsenable] = useState(false);
  const [loader, setLoader] = useState(false);
  const mobileNoRegex = /^[0-9\b]+$/;
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 440);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 440);
    };
  
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  

  const [state, setState] = useState({
    minutes: 0,
    seconds: 0,
    resendOtp: false,
    otp: "",
    is_button_disabled: false,
  });


  
  const setPhone = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    let arr = ["6", "7", "8", "9"];

    if (value === "" || mobileNoRegex.test(value)) {
     

      if (arr.includes(value[0]) || value === "" || value[1]) {
        if (value[0] === "0") {
          setmobileNumber(value.slice(1, 11));

          if (value.length >= 10) {
           
          }
        } else {
          setmobileNumber(value.slice(0, 10));

          if (value.length >= 10) {
           
          }
        }
      }
    }
    if (value.length === 10) {
      setState({ is_enable: true });
    } else {
      setState({ is_enable: false });
    }
  };

  const handleRedirect = () => {
    // window.open('https://www.paymeindia.in/terms/', '_blank', 'noopener,noreferrer');
  };

  const handleprivacypolicyredirect = () => {
    // window.open('https://www.paymeindia.in/privacy-policy/', '_blank', 'noopener,noreferrer');
  };

  const redirectUrl = (url) => {
    window.open(url, "_blank");
  };

  const hanldePhoneNumberVerify = (e) => {
   
  
    setLoader(true);
    e.preventDefault();
  
    // Extract phone_number from query params
    const urlParams = new URLSearchParams(window.location.search);
    const phone_number_from_query = urlParams.get("phone_number");
  
    // Check if the phone number from the query is the same as the entered phone number
    // if (phone_number === phone_number_from_query) {
    //   ToastMsg("Phone Number already exist!!", "error");
    //   setLoader(false);
    //   return;
    // }
    let token = localStorage.getItem("gpay_token");
    props
      .sendOtpNotExist(token,{
        phone_number,
        
      }
    )
      .then((res) => {
        setState({ loading: false });
        setLoader(false);
        navigate(`/verifyOtpmoble?phone_number=${phone_number}`);
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
      });
  };
  



  const [phone_number, setmobileNumber] = useState("");
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  const goToPrevPage = () => setPageNumber(pageNumber - 1);

  const goToNextPage = () => setPageNumber(pageNumber + 1);

  const handleChange = (event) => {
    if (event.target.checked) {
      setIsenable(true);
    } else {
      setIsenable(false);
    }
  };
  // console.log("local", localStorage, pdf); 

  return (
    <div id="background" className="main_div">
       {isLargeScreen &&
          <div style={{marginBottom:0}} className="customheading sticky-header shadowlinepurebottom">
          <img  style={{cursor:"pointer", marginLeft: "30px"}} className="customimgfix ml-20" src={arrowleft} onClick={() => {
          // window.location.href="/dashboard_s";
          navigate(-1)
          }} />
          
           <h1 className="boldheading " style={{ paddingLeft:"65px", color:'#152745', fontWeight:'800', fontSize:'25px' , maxWidth: "270px"}}>{HEADING_CHANGE_MOBILE_NUMBER}</h1>
          </div>}
      <div className="toolbarRespo">
        <div className="pb-4">
          {/* <Heading
            headingText={HEADING_CHANGE_MOBILE_NUMBER}
            backprops={"/apply_loan"}
            history={props.history}
          /> */}
          {!isLargeScreen &&
          <div style={{marginBottom:0}} className="customheading maxWidth450 shadowlinepurebottom">
          <img  style={{cursor:"pointer", marginLeft: "30px"}} className="customimgfix ml-20" src={arrowleft} onClick={() => {
          // window.location.href="/dashboard_s";
          navigate(-1)
          }} />
          
           <h1 className="boldheading " style={{ paddingLeft:"65px", color:'#152745', fontWeight:'800', fontSize:'25px' , maxWidth: "270px"}}>{HEADING_CHANGE_MOBILE_NUMBER}</h1>
          </div>}
          <div style={{marginTop: "10vh"}} className="wrapper-content container">
            <div style={{marginBottom:"20vh"}} className=" px-4 pb-3 pt-1 w-100 text-center mx-auto ">
              <div className="h-100 d-flex flex-column justify-content-between">
                <div className="pt-4">
                  {/* <div>
                    <section className="centered">
                      <Document
                        file={pdf}
                        onLoadSuccess={onDocumentLoadSuccess}
                        renderMode="canvas"
                        loading="Preparing the document..."
                      >
                        <Page pageNumber={pageNumber} />
                      </Document>

                      <p style={{ textAlign: "center" }}>
                        Page {pageNumber} of {numPages}
                      </p>
                    </section>
                    <section className="icons-pdf">
                      <button onClick={goToPrevPage} disabled={pageNumber <= 1}>
                        <i
                          className="fa fa-long-arrow-left"
                          aria-hidden="true"
                        ></i>
                      </button>
                      <button
                        onClick={goToNextPage}
                        disabled={pageNumber === numPages}
                      >
                        <i
                          className="fa fa-long-arrow-right"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </section>
                  </div> */}

<div className="h-100 d-flex flex-column justify-content-between">




              <div >
               
                {/* <img
                  src={changenumber}
                  style={{ width: 180, height: 238 }}
                  className="mobile"
                  alt="PaymeIndia"
                /> */}
                <br/> <br/>
                <p className="mobile_Numberone bolderr" >Mobile number</p>  <br/> <br/>
                <div className="input-wrapper ">   
              <input
                className="input"
                type="text"
                data-testid="input_phonnenumber"
                maxLength={10}
                value={phone_number}
                name="phone_number"
                onChange={setPhone}
                style={{marginLeft:"0 !important"}}
               
                placeholder=" "
              />
              <label style={{marginLeft: 15}} className="label">Enter Mobile Number</label>
    </div>
                            
              </div>
              <div style={{ clear: "both", width: "100%" }}>
  <div
    style={{
      paddingTop: 5,
      clear: "both",
      width: "100%",
      paddingLeft: 20,
    }}
  >
    <div className="flex items-start gap-2">
      {/* Checkbox only clickable by itself */}
      <input
        className="Termscheckbox"
        type="checkbox"
        checked={isChecked}
        onChange={(e) => {
          setIsChecked(e.target.checked);
          setIsenable(e.target.checked);
        }}
        id="terms"
        name="terms"
      />

      {/* Agreement text clickable separately */}
      <p className="checkText halftext">
        By clicking, I agree to the{" "}
        <span className="homepageconcent">
          <span onClick={() => redirectUrl(process.env.REACT_APP_T_C)}style={{ cursor: "pointer" }}>
            Terms and Conditions
          </span>
          ,{" "}
          <span
            onClick={() => redirectUrl(process.env.REACT_APP_PRIVACY_POLICY)}
            style={{ cursor: "pointer" }}
          >
            Privacy Policy
          </span>
        </span>
      </p>
    </div>
  </div>
</div>
            </div>
                </div>
              </div>
            </div>
          </div>
        </div>
       
        <div className="text-center">
          {is_enable === true && phone_number.length === 10  ? (
            <button
              className="bg-orange text-white newbtnDesign  py-6"
              onClick={ hanldePhoneNumberVerify }
            >
              Get OTP
            </button>
          ) : (
            <button className="bg-orange text-white newbtnDesign  py-6 opacity-50">
              Get OTP
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
export default withRouter(connect(mapStateToProps, 
    {  
    savePhoneNumber,
    saveManualToken,
    phoneNumberVerify,
    sendOtpNotExist,
    resendOtp,
    refreshToken,
    

    })
    (ChangeMobileNumber));
